import React from "react";
import { Alert, Button } from "@mui/joy";

interface ErrorAlertProps {
  show: boolean;
  message: string;
  onClose: () => void;
}

export const ErrorAlert: React.FC<ErrorAlertProps> = ({
  show,
  message,
  onClose,
}) => {
  if (!show) return null;

  return (
    <Alert
      color="danger"
      variant="soft"
      sx={{
        m: 2,
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 50,
      }}
      endDecorator={
        <Button variant="soft" color="danger" onClick={onClose}>
          Close
        </Button>
      }
    >
      {message}
    </Alert>
  );
};
